import { Button, Icon } from "@weezevent/nacre";
import React from "react";

const MainCtaCreateButton = ({ ...rest }) => (
	/**
	 * A main CTA, for display on top of page,
	 * intended only for creating new objects.
	 */
	<Button
		primary
		fluid
		onlyIconMobile={false}
		align="left"
		icon={<Icon name="plus" />}
		{...rest}
	/>
);

export default MainCtaCreateButton;
